import { render, staticRenderFns } from "./ApiLookupSectionedForm.vue?vue&type=template&id=c1687962&scoped=true&"
import script from "./ApiLookupSectionedForm.vue?vue&type=script&lang=js&"
export * from "./ApiLookupSectionedForm.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupSectionedForm.vue?vue&type=style&index=0&id=c1687962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1687962",
  null
  
)

export default component.exports